import { CustomSpin } from "../topia/UI/CustomSpin";
import "./style.css";

export const CheckingAuth = () => {
	return (
		<CustomSpin fullScreen customIcon spinning={true} />
	);
};
